/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import ENV from "react-dotenv";


import React, {useState, useEffect, useContext} from "react";

import {useDispatch} from "react-redux";

import CHANGE_API_REQUEST_STATUS_ACTION from "@Actions/Interface/ChangeApiRequestStatus";

import {LOG_USER_IN_ACTION} from "@Actions/Authentication";
import LOGGED_USER_INTERFACE from "@Store/Interfaces/Authentication/User";

import {useTypedSelector} from "@Services/Hooks/UseTypedSelector";


import {Helmet} from "react-helmet";


import ApplicationApiContext from "@Contexts/Api";


import {Redirect} from "react-router-dom";


import validator from "validator";


import BlockContentContainerComponent from "@Components/UI/Containers/Block";
import BlockContentHeaderComponent from "@Components/UI/Containers/Block/Header";


import RegisterFormStepsComponent from "@UIPages/NotAuthenticated/Register/Steps";


import validatePeselNumber from "@Utilities/Validators/Pesel";
import validateUserPassword from "@Utilities/Validators/Password";
import {Col} from "react-bootstrap";
import BlockContentPictureComponent from "@Components/UI/Containers/Block/Picture";
import ApplicationHeaderComponent from "@UIParts/Header";
import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";
import CHANGE_API_REQUEST_TOKEN_ACTION from "@Actions/Api/ChangeApiRequestTokenValue";
import prepareRestApiRequestToken from "@Services/Utilities/RequestToken/Prepare";


export interface RegisterFormErrorsInterface {
    registrationProcess?: string;
    formUserIdNumber?: string | null;
    formUserFirstName?: string | null;
    formUserLastName?: string | null;
    formUserPassword?: string | null;
    formUserPasswordRepeat?: string | null;
    formUserPIN?: string | null;
    formUserPhoneNumber?: string | null;
    formUserRegulations?: string | null;
    formUserPrivacy?: string | null;
    formUserSMSCode?: string | null;
}


interface RegisterFormFieldsInterface {
    formUserIdNumber?: string;
    formUserFirstName?: string;
    formUserLastName?: string;
    formUserOperationGuid?: string,
    formUserGeneratedID?: string,
    formUserGeneratedLogin?: string,
    formUserGeneratedPasswordRequirements?: [],
    formUserPassword?: string;
    formUserPasswordRepeat?: string;
    formUserPIN?: string;
    formUserPhoneNumber?: string;
    formUserFormalsStatus?: boolean,
    formUserRegulations?: [],
    formUserRegulationAcceptedStatus?: boolean;
    formUserPrivacyAcceptedStatus?: boolean;
    formUserFormalsAcceptationDate?: Date | null;
    formUserSMSCode?: string;
    formUserSMSCodeValidTime?: number;
    formUserSMSCodeNumber?: number;
}


const RegisterFormFields: RegisterFormFieldsInterface = {
    formUserIdNumber: "",
    formUserFirstName: "",
    formUserLastName: "",
    formUserOperationGuid: "",
    formUserGeneratedID: "",
    formUserGeneratedLogin: "",
    formUserGeneratedPasswordRequirements: [],
    formUserPassword: "",
    formUserPasswordRepeat: "",
    formUserPIN: "",
    formUserPhoneNumber: "",
    formUserFormalsStatus: false,
    formUserRegulations: [],
    formUserRegulationAcceptedStatus: false,
    formUserPrivacyAcceptedStatus: false,
    formUserFormalsAcceptationDate: null,
    formUserSMSCode: "",
    formUserSMSCodeValidTime: 0,
    formUserSMSCodeNumber: 1
};


interface REGISTER_FORM_REQUEST_HANDLER_INTERFACE {
    error?: boolean, code?: number, message?: string,
    success?: boolean, data?: any
}

type REGISTER_FORM_REQUEST_HANDLER_RETURN_TYPE = REGISTER_FORM_REQUEST_HANDLER_INTERFACE | null;


export type REGISTER_FORM_STEP_TYPE = 1 | 2 | 3 | 4 | 5;


export const RegisterPageComponent: React.FC = (): JSX.Element | null => {


    /** @type {UserInterface | null} Application Logged User (from Global Store Object */
    const LOGGED_USER: LOGGED_USER_INTERFACE = useTypedSelector(
        (state):ReturnType<any> => state?.authentication
    )?.loggedUser || null;


    /** @var {APP_NAME} Application Name - Environment Variable */
    const {APP_NAME} = ENV || {};


    /** @var {STORED_REGISTER_FORM_DATA} Stored in local storage Register Form Data */
    const STORED_REGISTER_FORM_DATA = localStorage.getItem(`${APP_NAME}_REGISTER_FORM_DATA`);
    /** @var {REGISTER_FORM_DATA} Parsed stored Register Form Data */
    const REGISTER_FORM_DATA = STORED_REGISTER_FORM_DATA ? JSON.parse(STORED_REGISTER_FORM_DATA) : RegisterFormFields;


    /** @var {DISPATCHER} Global State Actions Dispatcher */
    const DISPATCHER = useDispatch();


    /** @var {REST_API_URL} Global Rest Api Root URL Address */
    const REST_API_URL = useContext(ApplicationApiContext)?.API_ROOT_URL;


    /** */
    const [registerFormStep, setRegisterFormStep] = useState<REGISTER_FORM_STEP_TYPE>(1);

    /** */
    const [registerFormErrors, setRegisterFormErrors] = useState<RegisterFormErrorsInterface>({});


    /**
     * @var {formUserIdNumberDefault}
     * @var {formUserFirstNameDefault}
     * @var {formUserLastNameDefault}
     * @var {formUserOperationGuidDefault}
     * @var {formUserGeneratedIDDefault}
     * @var {formUserGeneratedLoginDefault}
     * @var {formUserGeneratedPasswordRequirementsDefault}
     * @var {}
     * @var {}
     * @var {}
     * */
    // const {
    //     formUserIdNumber: formUserIdNumberDefault,
    //     formUserFirstName: formUserFirstNameDefault, formUserLastName: formUserLastNameDefault,
    //     formUserOperationGuid: formUserOperationGuidDefault,
    //     formUserGeneratedID: formUserGeneratedIDDefault, formUserGeneratedLogin: formUserGeneratedLoginDefault,
    //     formUserGeneratedPasswordRequirements: formUserGeneratedPasswordRequirementsDefault,
    //     formUserPIN: formUserPINDefault, formUserPhoneNumber: formUserPhoneNumberDefault,
    //     formUserFormalsStatus: formUserFormalsStatusDefault, formUserRegulations: formUserRegulationsDefault,
    //     formUserRegulationsAcceptedStatus: formUserRegulationsAcceptedStatusDefault,
    //     formUserPrivacyAcceptedStatus: formUserPrivacyAcceptedStatusDefault,
    //     formUserFormalsAcceptationDate: formUserFormalsAcceptationDateDefault
    // } = REGISTER_FORM_DATA;


    /** @var {}  */
    const [formUserIdNumber, setFormUserIdNumber] = useState<string>("");
    /** @var {} */
    const [formUserFirstName, setFormUserFirstName] = useState<string>("");
    /** @var {} */
    const [formUserLastName, setFormUserLastName] = useState<string>("");

    /** @var {} */
    const [formUserOperationGuid, setFormUserOperationGuid] = useState<string>("");
    /** @var {} */
    const [formUserGeneratedID, setFormUserGeneratedID] = useState<string>("");
    /** @var {} */
    const [formUserGeneratedLogin, setFormUserGeneratedLogin] = useState<string>("");
    /** @var {} */
    const [formUserGeneratedPasswordRequirements, setFormUserGeneratedPasswordRequirements] = useState<[]>([]);

    /** @var {} */
    const [formUserPassword, setFormUserPassword] = useState<string>("");
    /** @var {} */
    const [formUserPasswordRepeat, setFormUserPasswordRepeat] = useState<string>("");
    /** @var {} */
    const [formUserPIN, setFormUserPIN] = useState<string>("");
    /** @var {} */
    const [formUserPhoneNumber, setFormUserPhoneNumber] = useState<string>("");

    /** @var {} */
    const [formUserFormalsStatus, setFormUserFormalsStatus] = useState<boolean>(false);
    const [formUserRegulations, setFormUserRegulations] = useState<[] | boolean>([]);
    /** @var {} */
    const [formUserRegulationsAcceptedStatus, setFormUserRegulationsAcceptedStatus] = useState<boolean>(false);
    /** @var {} */
    const [formUserPrivacyAcceptedStatus, setFormUserPrivacyAcceptedStatus] = useState<boolean>(false);
    /** @var {} */
    const [formUserFormalsAcceptationDate, setFormUserFormalsAcceptationDate] = useState<Date | null>(null);

    /** @var {} */
    const [formUserSMSCode, setFormUserSMSCode] = useState<string>("");
    const [formUserSMSCodeNumber, setFormUserSMSCodeNumber] = useState<number>(1);
    /** @var {} */
    const [formUserSMSCodeValidTime, setFormUserSMSCodeValidTime] = useState<number>(0);

    /** @var {} */
    const [registerFormSubmitSuccessStatus, setRegisterFormSubmitSuccessStatus] = useState<boolean>(false)


    /**
     * @Hooks - Did Mount (after first Render)
     * Set Active Register form Step
     */
    useEffect(() => {
        let registerFormStep: REGISTER_FORM_STEP_TYPE = 1;
        if (formUserGeneratedID && !!formUserIdNumber) registerFormStep = 2;
        if (formUserFormalsStatus) registerFormStep = 3;
        if (formUserFormalsAcceptationDate && !!formUserSMSCodeValidTime) registerFormStep = 4;
        setRegisterFormStep(registerFormStep);
        return () => {

        };
    }, []);


    /**
     *
     * @param e
     */
    const changeFormUserIdNumberHandler = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (registerFormStep !== 1) return; // if step != 1 do nothing
        /** @var {} */
        const userIdNumber: string = e.target.value;
        if (validatePeselNumber(userIdNumber)) setRegisterFormErrors({...registerFormErrors, formUserIdNumber: null});
        setFormUserIdNumber(userIdNumber); // update Register Form User ID Number
    };

    const changeFormUserFirstName = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (registerFormStep !== 1) return; // if step != 1 do nothing
        /** @var {} */
        const userFirstName: string = e.target.value;
        if (userFirstName.length > 2) setRegisterFormErrors({...registerFormErrors, formUserFirstName: null});
        setFormUserFirstName(userFirstName); // update Register Form User First Name
    };

    const changeFormUserLastName = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (registerFormStep !== 1) return; // if step != 1 do nothing
        const userLastName: string = e.target.value;
        if (userLastName.length > 2) setRegisterFormErrors({...registerFormErrors, formUserLastName: null});
        setFormUserLastName(userLastName); // update Register Form User Last Name
    };

    const changeFormUserPassword = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (registerFormStep !== 2) return;
        const userPassword = e.target.value;
        if (validateUserPassword(userPassword)) setRegisterFormErrors({...registerFormErrors, formUserPassword: null});
        setFormUserPassword(userPassword);
    };

    const changeFormUserPasswordRepeat = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (registerFormStep !== 2) return;
        const userPasswordRepeat = e.target.value;
        if (userPasswordRepeat === formUserPassword) setRegisterFormErrors({...registerFormErrors, formUserPasswordRepeat: null});
        setFormUserPasswordRepeat(userPasswordRepeat);
    };

    const changeFormUserPIN = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (registerFormStep !== 2) return;
        const userPIN = e.target.value;
        if (userPIN.length > 4) return;
        if (userPIN.length === 4 && !isNaN(+formUserPIN)) setRegisterFormErrors({...registerFormErrors, formUserPIN: null});
        setFormUserPIN(userPIN);
    };

    const changeFormUserPhoneNumber = (e: React.ChangeEvent<HTMLInputElement>): void => {
        if (registerFormStep !== 2) return;
        const userPhoneNumber = e.target.value;
        if (validator.isMobilePhone(userPhoneNumber, ["pl-PL"])) setRegisterFormErrors({...registerFormErrors, formUserPhoneNumber: null});
        setFormUserPhoneNumber(userPhoneNumber);
    };

    const changeFormUserSMSCode = (e: React.ChangeEvent<HTMLInputElement> | string): void => {
        if (registerFormStep !== 4) return;
        const userSMSCode = typeof e === "string" ? e : e.target.value;
        if (userSMSCode.length > 6) return;
        if (userSMSCode.length === 6) setRegisterFormErrors({...registerFormErrors, formUserSMSCode: null});
        setFormUserSMSCode(userSMSCode);
    };


    const [enterKeyPressCount, setEnterKeyPressCount] = useState<number>(0);

    useEffect(() => {
        let n = 0;
        const HANDLER = (e: KeyboardEvent) => {
            if (e.key === "Enter") setEnterKeyPressCount(++n);
        }
        document.addEventListener("keydown", HANDLER);
        return () => document.removeEventListener("keydown", HANDLER);
    }, []);

    useEffect(() => {
        if (enterKeyPressCount === 0) return;
        let newRegisterFormStep = registerFormStep;
        if (registerFormStep === 1) newRegisterFormStep = 2;
        if (registerFormStep === 2) newRegisterFormStep = 3;
        if (registerFormStep === 3) newRegisterFormStep = 4;
        if (registerFormStep === 4) newRegisterFormStep = 5;
        changeRegisterFormStep(newRegisterFormStep);
    }, [enterKeyPressCount]);


    const REGISTER_FORM_REQUEST_HANDLER = async (finalStep: boolean = false): Promise<REGISTER_FORM_REQUEST_HANDLER_RETURN_TYPE> => {

        if (!REST_API_URL) return null;

        let REGISTER_FORM_STEP_URL: string = `${REST_API_URL}/User`;
        let REGISTER_FORM_STEP_DATA: string = "";

        switch (registerFormStep) {
            case 1:
                REGISTER_FORM_STEP_URL += "/Registration/Initialization";
                REGISTER_FORM_STEP_DATA = JSON.stringify({
                    pesel: formUserIdNumber, firstname: formUserFirstName, surname: formUserLastName
                });
                break;
            case 2:
                REGISTER_FORM_STEP_URL += "/Registration/Step1";
                REGISTER_FORM_STEP_DATA = JSON.stringify({
                    OperationGUID: formUserOperationGuid,
                    UserId: formUserGeneratedID,
                    Password: btoa(formUserPassword), CardPIN: formUserPIN, Phone: formUserPhoneNumber
                });
                break;
            case 3:
                REGISTER_FORM_STEP_URL += "/Registration/Step2";
                REGISTER_FORM_STEP_DATA = JSON.stringify({
                    OperationGUID: formUserOperationGuid,
                    UserId: formUserGeneratedID,
                    RegulationsAcceptDate: new Date()
                });
                break;
            case 4:
                REGISTER_FORM_STEP_URL += finalStep ? "/Registration/Finalization" : "/GenerateVerificationCode";
                if (finalStep) {
                    REGISTER_FORM_STEP_DATA = JSON.stringify({
                        OperationGUID: formUserOperationGuid,
                        UserId: formUserGeneratedID,
                        VerificationCode: formUserSMSCode
                    });
                } else {
                    REGISTER_FORM_STEP_DATA = JSON.stringify({
                        OperationGUID: formUserOperationGuid,
                        UserId: formUserGeneratedID
                    });
                }
                break;
        }

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(true));

        try {

            const RESPONSE = await fetch(
                REGISTER_FORM_STEP_URL, {
                    method: "POST",
                    headers: {"Content-Type": "application/json"},
                    body: REGISTER_FORM_STEP_DATA
                }
            );

            const CONTENT = RESPONSE.status !== 204 ? await RESPONSE.json() : null;

            if (RESPONSE.status !== 200 && RESPONSE.status !== 204) {
                DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));
                if (RESPONSE.status === 409) {
                    return {error: true, code: registerFormStep, message: CONTENT?.UserMessage};
                } else {
                    return {error: true, code: 500, message: "Wystąpił nieokreślony błąd - skontaktuj się z CDOK"};
                }
            }

            switch (registerFormStep) {
                case 1:
                    registerFormStep1ResponseHandler(CONTENT);
                    break;
                case 2:
                    registerFormStep2ResponseHandler(CONTENT);
                    break;
                case 3:
                    registerFormStep3ResponseHandler(CONTENT);
                    break;
                case 4:
                    if (finalStep) {
                        registerFormStep4ResponseHandler();
                    } else {
                        DISPATCHER(CHANGE_API_REQUEST_TOKEN_ACTION(
                            prepareRestApiRequestToken(RESPONSE.headers)
                        ));
                        registerFormStep3ResponseHandler(CONTENT);
                    }
                    break;
            }

        } catch (e) {
            DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));
            return {error: true, code: 500, message: "Błąd połączenia z serwisem - skontaktuj się z CDOK"};
        }

        DISPATCHER(CHANGE_API_REQUEST_STATUS_ACTION(false));

        return {success: true, data: {}};

    };


    const validateRegisterFormStep1 = (): boolean => {

        const formErrors: RegisterFormErrorsInterface = {};

        // if (!validatePeselNumber(formUserIdNumber)) formErrors.formUserIdNumber = "Niepoprawny numer pesel";
        if (formUserFirstName.length < 3) formErrors.formUserFirstName = "Podane Imię jest zbyt krótkie";
        if (formUserLastName.length < 3) formErrors.formUserLastName = "Podane Nazwisko jest zbyt krótkie";

        setRegisterFormErrors(formErrors);

        return !Object.entries(formErrors).length;

    }

    const registerFormStep1ResponseHandler = (content: any): void => {

        const {
            OperationGUID: operationGUID,
            UserId: generatedUserId,
            Login: generatedUserLogin,
            PasswordRequirments: generatedUserPasswordRequirements
        } = content;

        setFormUserOperationGuid(operationGUID);
        setFormUserGeneratedID(generatedUserId);
        setFormUserGeneratedLogin(generatedUserLogin);
        setFormUserGeneratedPasswordRequirements(generatedUserPasswordRequirements);

        storeRegisterFormData({
            formUserOperationGuid: operationGUID,
            formUserGeneratedID: generatedUserId,
            formUserGeneratedLogin: generatedUserLogin,
            formUserGeneratedPasswordRequirements: generatedUserPasswordRequirements
        });

    };


    const validateRegisterFormStep2 = (): boolean => {

        const formErrors: RegisterFormErrorsInterface = {};

        if (!validateUserPassword(formUserPassword)) formErrors.formUserPassword = "Podane Hasło jest nieprawidłowe";
        if (formUserPasswordRepeat !== formUserPassword) formErrors.formUserPasswordRepeat = "Podane Hasła różnią się";
        // if (formUserPIN.length !== 4 || isNaN(+formUserPIN)) formErrors.formUserPIN = "Podany PIN ma nieprawidłowy format";
        // if (!validator.isMobilePhone(formUserPhoneNumber, ["pl-PL"])) formErrors.formUserPhoneNumber = "Podane Numer Telefonu jest nieprawidłowy";
        if (formUserPhoneNumber.length < 9) formErrors.formUserPhoneNumber = "Podane Numer Telefonu jest nieprawidłowy";

        setRegisterFormErrors(formErrors);

        return !Object.entries(formErrors).length;

    }


    const registerFormStep2ResponseHandler = (CONTENT: any): void => {
        storeRegisterFormData({formUserFormalsStatus: true, formUserRegulations: CONTENT.Regulations});
        setFormUserFormalsStatus(true);
        setFormUserRegulations(CONTENT.Regulations?.length ? CONTENT.Regulations : false);
    };


    const validateRegisterFormStep3 = (): boolean => {

        const formErrors: RegisterFormErrorsInterface = {};

        if (!formUserRegulationsAcceptedStatus) formErrors.formUserRegulations = "Akceptacja Regulaminów jest obowiązkowa";

        setRegisterFormErrors(formErrors);

        return !Object.entries(formErrors).length;

    };


    const registerFormStep3ResponseHandler = (content: any): void => {
        const {
            VerificationCodeNo: codeNo,
            VerificationCodeValidDate: smsCodeValidDate
        } = content;
        const smsCodeValidDateTime = new Date(smsCodeValidDate);
        const smsCodeValidLeftTime = smsCodeValidDateTime.getTime() - (new Date()).getTime();
        storeRegisterFormData({formUserFormalsAcceptationDate: new Date()});
        setFormUserFormalsAcceptationDate(new Date());
        setFormUserSMSCodeValidTime(Math.floor(smsCodeValidLeftTime / 1000));
        setFormUserSMSCodeNumber(+codeNo || 1);
    };


    const validateRegisterFormStep4 = (): boolean => {

        const formErrors: RegisterFormErrorsInterface = {};

        // if (formUserSMSCode.length !== 6 || isNaN(+formUserSMSCode)) formErrors.formUserSMSCode = "Kod jest nieprawidłowy";

        setRegisterFormErrors(formErrors);

        return !Object.entries(formErrors).length;

    };

    const registerFormStep4ResponseHandler = (): void => {

        localStorage.removeItem(`${APP_NAME}_REGISTER_FORM_DATA`);

        DISPATCHER(LOG_USER_IN_ACTION({
            userID: formUserGeneratedID,
            userLogin: formUserGeneratedLogin,
            userFirstName: formUserFirstName,
            userLastName: formUserLastName,
            userLoginTime: new Date(),
            userLastActivityTime: new Date()
        }));

    };



    const changeRegisterFormStep = async (step: REGISTER_FORM_STEP_TYPE, finalStep: boolean = false): Promise<boolean | null> => {

        let formError: boolean = false;

        switch (registerFormStep) {
            case 1: formError = !validateRegisterFormStep1(); break;
            case 2: formError = !validateRegisterFormStep2(); break;
            case 3: formError = !validateRegisterFormStep3(); break;
            case 4: if (finalStep) formError = !validateRegisterFormStep4(); break;
            default: return null;
        }

        if (formError) return null;

        const stepResponse = await REGISTER_FORM_REQUEST_HANDLER(finalStep);

        if (!stepResponse || stepResponse?.error) {
            setRegisterFormErrors({...registerFormErrors, registrationProcess: stepResponse?.message});
            return null;
        }

        setRegisterFormStep(step);

        return true;

    };


    const storeRegisterFormData = (updatedFields?: RegisterFormFieldsInterface) => {

        // const REGISTER_FORM_DATA = {
        //     formUserIdNumber, formUserFirstName, formUserLastName,
        //     formUserOperationGuid, formUserGeneratedID, formUserGeneratedLogin, formUserGeneratedPasswordRequirements,
        //     formUserPIN, formUserPhoneNumber,
        //     formUserFormalsStatus, formUserRegulationsAcceptedStatus, formUserPrivacyAcceptedStatus, formUserFormalsAcceptationDate
        // };

        // const STORE_FORM_DATA = {...REGISTER_FORM_DATA, ...updatedFields};
        // localStorage.setItem(`${APP_NAME}_REGISTER_FORM_DATA`, JSON.stringify(STORE_FORM_DATA));

    };


    const resetRegisterFormHandler = () => {

        setFormUserIdNumber("");
        setFormUserFirstName("");
        setFormUserLastName("");

        setFormUserGeneratedID("");
        setFormUserGeneratedLogin("");
        setFormUserGeneratedPasswordRequirements([]);

        setFormUserPassword("");
        setFormUserPasswordRepeat("");
        setFormUserPIN("");
        setFormUserPhoneNumber("");

        setFormUserFormalsStatus(false);
        setFormUserFormalsAcceptationDate(null);
        setFormUserRegulationsAcceptedStatus(false);
        setFormUserPrivacyAcceptedStatus(false);

        setFormUserSMSCode("");
        setFormUserSMSCodeValidTime(0);

        setRegisterFormStep(1);
        setRegisterFormErrors({});

        localStorage.removeItem(`${APP_NAME}_REGISTER_FORM_DATA`);

    };


    useEffect(() => {
        return () => resetRegisterFormHandler();
    }, []);


    if (LOGGED_USER && LOGGED_USER?.userID) return <Redirect to={"/"} />;


    if (registerFormStep === 5) return null;


    return (
        <BlockContentContainerComponent as={"main"} cssClasses={"register-page-component"}>

            <Helmet>
                <title>{`SAMER®TAS eKiosk - Rejestracja`}</title>
            </Helmet>

            <ApplicationHeaderComponent />

            <Col xs={12} as={"h2"} className={"login-page-header user-form-header"}>
                <span>{`eKiosk - Aplikacja dla Kierowcy`}</span>
            </Col>

            <BlockContentPictureComponent headerPictureType={2} />

            {formUserRegulations === false ?

            <ErrorMessageComponent messageText={`W danym momencie nie są dostępne żadne regulaminy. Skontaktuj się z CDOK`} />

            :

            <RegisterFormStepsComponent
                registerFormStep={registerFormStep}
                registerFormErrors={registerFormErrors}
                registerFormErrorsHandler={setRegisterFormErrors}
                registerFormStepHandler={changeRegisterFormStep}
                formResetHandler={resetRegisterFormHandler}
                formUserIdNumber={formUserIdNumber}
                formUserIdNumberHandler={changeFormUserIdNumberHandler}
                formUserFirstName={formUserFirstName}
                formUserFirstNameHandler={changeFormUserFirstName}
                formUserLastName={formUserLastName}
                formUserLastNameHandler={changeFormUserLastName}
                formUserGeneratedID={formUserGeneratedID}
                formUserGeneratedLogin={formUserGeneratedLogin}
                formUserGeneratedPasswordRequirements={formUserGeneratedPasswordRequirements}
                formUserPassword={formUserPassword}
                formUserPasswordHandler={changeFormUserPassword}
                formUserPasswordRepeat={formUserPasswordRepeat}
                formUserPasswordRepeatHandler={changeFormUserPasswordRepeat}
                formUserPIN={formUserPIN}
                formUserPINHandler={changeFormUserPIN}
                formUserPhoneNumber={formUserPhoneNumber}
                formUserPhoneNumberHandler={changeFormUserPhoneNumber}
                formUserRegulationsAcceptedStatus={formUserRegulationsAcceptedStatus}
                formUserRegulationsAcceptedStatusHandler={setFormUserRegulationsAcceptedStatus}
                formUserPrivacyAcceptedStatus={formUserPrivacyAcceptedStatus}
                formUserPrivacyAcceptedStatusHandler={setFormUserPrivacyAcceptedStatus}
                formUserRegulations={formUserRegulations}
                formUserRegulationsHandler={setFormUserRegulations}
                formUserSMSCode={formUserSMSCode}
                formUserSMSCodeHandler={changeFormUserSMSCode}
                formUserSMSCodeValidTime={formUserSMSCodeValidTime}
                formUserSMSCodeNumber={formUserSMSCodeNumber}
                formUserSMSCodeValidTimeHandler={setFormUserSMSCodeValidTime}
            />

            }

        </BlockContentContainerComponent>
    )

};


export default RegisterPageComponent;
